import { useUpdateEffect as libUseUpdateEffect } from 'react-use';

export const useUpdateEffect = libUseUpdateEffect;
